<template>
<svg
  :width="width"
  :height="height"
  viewBox="0 0 29 26"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  :id="iconName"
>
    <title :id="iconName">{{iconName}}</title>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linejoin="round">
        <g id="RetVejkode-left-panel" transform="translate(-26.000000, -22.000000)" stroke="#8954BA" stroke-width="1.5">
            <g id="Group-17" transform="translate(-230.000000, 0.000000)">
                <g id="Group-14" transform="translate(257.000000, 23.000000)">
                    <polyline id="Stroke-107" stroke-linecap="round" points="27 12 13.5 0 0 12"></polyline>
                    <polyline id="Stroke-108" points="24 9 24 24 16.5868852 24 16.5868852 14.0589848 10.4131148 14.0589848 10.4131148 24 3 24 3 9"></polyline>
                </g>
            </g>
        </g>
    </g>
</svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box',
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
  },
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px;
}
</style>
